import { Outlet } from 'react-router-dom';

import ScreenWrapper from '@/components/ui/ScreenWrapper';
import ErrorBoundary from '@/components/ErrorBoundary';
import NeuerStandWaechter from '@/components/NeuerStandWaechter';
import KundenMailRueckfrageDialog from '@/components/modals/KundenMailRueckfrageDialog';

const RootView = () => {
  return (
    <ErrorBoundary>
      <ScreenWrapper>
        <NeuerStandWaechter>
          <Outlet />
        </NeuerStandWaechter>
        {/* Rückfrage nach geänderter Kunden-Mail (#254): hier, weil die Kunden-Mail
            auch in der Beratungsstrecke geändert wird und die neben HomeView liegt. */}
        <KundenMailRueckfrageDialog />
      </ScreenWrapper>
    </ErrorBoundary>
  );
};

export default RootView;
